new WOW().init();

jQuery('.slick-banner').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	slide: 'li',
	dots: false,
	arrows: false,
	autoplay: true,
  autoplaySpeed: 3000
  // adaptiveHeight: true
});

jQuery('.intro-slider').slick({
	slidesToShow: 2,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
		{
			breakpoint: 991,
			settings: {
			slidesToShow: 1,
			slidesToScroll: 1
			}
		},
		{
			breakpoint: 640,
			settings: {
			slidesToShow: 2,
			slidesToScroll: 1
			}
		}
	]
});


jQuery(document).ready(function(){
  // scroll down
  jQuery("#scroll-down").click(function() {
      jQuery('html,body').animate({
        scrollTop: jQuery("#intro").offset().top
      }, 'slow');
      return false;
  });

  // sticky header
  jQuery(window).scroll(function() {
    var topheader = jQuery('#header').height();
    var myheight = jQuery(window).scrollTop();
    if(myheight > topheader){
    	jQuery('.header').addClass('headersticky');
    }
    if(myheight < topheader){
    	jQuery('.header').removeClass('headersticky');
    }
  });
});

function openNav() {
	jQuery('#mySidenav').addClass('open');  
}

function closeNav() {
	jQuery('#mySidenav').removeClass('open');  
}